const basePath = '/el-drop/3d/characters';

export default {
    map: `${basePath}/map.png`,
    consumer: `${basePath}/consumer.png`,
    success: `${basePath}/success.png`,
}